import { Link } from 'react-router-dom';

export default function QuiSommesNousPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-slate-50 to-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="inline-block">
                <span className="text-sm font-semibold tracking-wider text-orange-500 uppercase">À propos de nous</span>
              </div>
              
              <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight font-serif">
                PULSAR FC, au service de l'émancipation citoyenne
              </h1>
              
              <p className="text-xl text-slate-600 leading-relaxed">
                PULSAR FC est une association d'intérêt général dédiée à la formation civique, l'insertion socioprofessionnelle et l'accompagnement des publics vulnérables. Notre mission : construire une société plus inclusive, solidaire et citoyenne.
              </p>
              
              <p className="text-lg text-slate-600 leading-relaxed">
                À travers nos programmes de formation en langue française, nos actions de sensibilisation aux enjeux numériques et notre accompagnement personnalisé, nous œuvrons chaque jour pour favoriser l'intégration, le développement des compétences et l'accès à l'emploi.
              </p>
            </div>
            
            {/* Right Image */}
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/27c64b526de21645366dff012fb47f87.jpg"
                  alt="Équipe PULSAR FC"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notre Vision */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <blockquote className="text-4xl lg:text-5xl font-serif text-slate-900 leading-tight">
              <span className="text-6xl text-orange-500">"</span>
              Former, accompagner et émanciper pour construire une société où chacun trouve sa place et contribue au bien commun
              <span className="text-6xl text-orange-500">"</span>
            </blockquote>
            
            <div className="flex items-center justify-center gap-3 pt-6">
              <span className="text-lg font-semibold text-slate-900">PULSAR FC</span>
              <span className="px-4 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold flex items-center gap-2 w-fit">
                <i className="ri-star-fill text-xs"></i>
                Association reconnue d'intérêt général
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Valeurs */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif mb-4">Nos valeurs fondamentales</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Des principes qui guident notre action quotidienne au service de l'intérêt général
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Valeur 1 */}
            <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center">
                <i className="ri-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Humanisme</h3>
              <p className="text-slate-600 leading-relaxed">
                Placer l'humain au cœur de nos actions, avec bienveillance, respect et dignité pour chaque personne accompagnée.
              </p>
            </div>
            
            {/* Valeur 2 */}
            <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center">
                <i className="ri-scales-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Égalité</h3>
              <p className="text-slate-600 leading-relaxed">
                Garantir l'accès aux droits et aux opportunités pour tous, sans discrimination, dans le respect des principes républicains.
              </p>
            </div>
            
            {/* Valeur 3 */}
            <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Solidarité</h3>
              <p className="text-slate-600 leading-relaxed">
                Créer du lien social, favoriser l'entraide et construire ensemble une société plus cohésive et fraternelle.
              </p>
            </div>
            
            {/* Valeur 4 */}
            <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Innovation sociale</h3>
              <p className="text-slate-600 leading-relaxed">
                Expérimenter de nouvelles approches pédagogiques et développer des solutions adaptées aux enjeux contemporains.
              </p>
            </div>
            
            {/* Valeur 5 */}
            <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Laïcité</h3>
              <p className="text-slate-600 leading-relaxed">
                Promouvoir les valeurs de la République, le vivre-ensemble et le respect de la diversité dans un cadre laïque.
              </p>
            </div>
            
            {/* Valeur 6 */}
            <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center">
                <i className="ri-rocket-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Émancipation</h3>
              <p className="text-slate-600 leading-relaxed">
                Donner à chacun les moyens de son autonomie, de son développement personnel et de sa participation citoyenne.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Notre Approche */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif mb-4">Notre approche pédagogique</h2>
              <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                Une méthodologie éprouvée, centrée sur l'apprenant et adaptée aux besoins de chaque public
              </p>
            </div>
            
            <div className="space-y-8">
              {/* Approche 1 */}
              <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex flex-col lg:flex-row gap-8 items-start">
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 bg-orange-100 rounded-2xl flex items-center justify-center">
                      <span className="text-3xl font-bold text-orange-500">01</span>
                    </div>
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-3xl font-bold text-slate-900">Accompagnement personnalisé</h3>
                    <p className="text-lg text-slate-600 leading-relaxed">
                      Chaque parcours est unique. Nous prenons le temps d'écouter, d'évaluer les besoins et de construire un projet adapté à chaque personne, en tenant compte de son histoire, ses compétences et ses aspirations.
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Approche 2 */}
              <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex flex-col lg:flex-row gap-8 items-start">
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 bg-slate-100 rounded-2xl flex items-center justify-center">
                      <span className="text-3xl font-bold text-slate-900">02</span>
                    </div>
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-3xl font-bold text-slate-900">Pédagogie active et participative</h3>
                    <p className="text-lg text-slate-600 leading-relaxed">
                      Nos formations privilégient l'apprentissage par l'action, les mises en situation concrètes et les échanges entre participants. L'objectif : développer des compétences directement mobilisables dans la vie quotidienne et professionnelle.
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Approche 3 */}
              <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex flex-col lg:flex-row gap-8 items-start">
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 bg-orange-100 rounded-2xl flex items-center justify-center">
                      <span className="text-3xl font-bold text-orange-500">03</span>
                    </div>
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-3xl font-bold text-slate-900">Suivi dans la durée</h3>
                    <p className="text-lg text-slate-600 leading-relaxed">
                      L'accompagnement ne s'arrête pas à la fin de la formation. Nous assurons un suivi post-formation pour garantir l'ancrage des acquis et soutenir les personnes dans leurs démarches d'insertion professionnelle et sociale.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Engagements */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div className="space-y-8">
                <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Nos engagements pour l'intérêt général</h2>
                
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-2xl text-white"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-slate-900 mb-2">Accessibilité universelle</h4>
                      <p className="text-slate-600">Garantir l'accès à nos services pour tous, sans barrière financière, sociale ou culturelle.</p>
                    </div>
                  </div>
                  
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-2xl text-white"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-slate-900 mb-2">Qualité et professionnalisme</h4>
                      <p className="text-slate-600">Maintenir des standards élevés dans nos formations et notre accompagnement, avec des formateurs qualifiés.</p>
                    </div>
                  </div>
                  
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-2xl text-white"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-slate-900 mb-2">Transparence et éthique</h4>
                      <p className="text-slate-600">Agir avec intégrité, rendre compte de nos actions et mesurer notre impact social de manière rigoureuse.</p>
                    </div>
                  </div>
                  
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-2xl text-white"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-slate-900 mb-2">Partenariats durables</h4>
                      <p className="text-slate-600">Collaborer étroitement avec les acteurs publics, associatifs et privés pour maximiser notre impact territorial.</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=diverse%20team%20of%20social%20workers%20educators%20and%20volunteers%20working%20together%20in%20modern%20community%20center%20showing%20collaboration%20teamwork%20and%20commitment%20to%20social%20mission&width=800&height=900&seq=team-commitment-pulsar&orientation=portrait"
                  alt="Engagements PULSAR FC"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-24 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold">Ensemble, construisons une société plus inclusive</h2>
            <p className="text-xl text-slate-300 leading-relaxed">
              Vous partagez nos valeurs ? Vous souhaitez contribuer à notre mission ? Contactez-nous pour échanger sur les possibilités de collaboration.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link 
                to="/contact" 
                className="px-12 py-4 bg-orange-500 text-white rounded-full font-semibold hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Nous contacter
              </Link>
              <Link 
                to="/nos-actions" 
                className="px-12 py-4 bg-white text-slate-900 rounded-full font-semibold hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Découvrir nos actions
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
